import * as React from 'react';
import _ = require('underscore');

import { ReactActionDialogBodyProps } from '~src/commonInfra/dialogs/ReactActionDialog';
import { OAuthCredentials } from '~src/connectivity/resources/OAuthCredentials';
import { AddOAuthCredentialAction } from '~src/connectivity/services/AddOAuthCredentialAction';
import { EditableConnection } from '~src/connectivity/services/EditConnectionDialog';
import { ListResult } from '~src/ts/fetchers/ListResult';
import { Filter } from '~src/ts/helpers/Filter';
import { SliceableHelper } from '~src/ts/helpers/SliceableHelper';
import { ResourceQuery } from '~src/ts/resources/ResourceQuery';
import { IOAuthCredential } from '~src/ts/ServerApi/types/IOAuthCredential';
import { EditOAuthConnectionDialogProps, EditOAuthConnectionDialogState } from '../../EditOAuthConnectionAction';
import { EditOAuthConnectionDialogEmbeddedToggle } from './EditOAuthConnectionDialogEmbeddedToggle';
import { EditOAuthConnectionDialogPrompt } from './EditOAuthConnectionDialogPrompt';
import { EditOAuthConnectionDialogTestConnection } from './EditOAuthConnectionDialogTestConnection';

export type EditOAuthConnectionDialogBodyProps = ReactActionDialogBodyProps<
    EditOAuthConnectionDialogProps,
    EditOAuthConnectionDialogState
>;

export function EditOAuthConnectionDialogBody(props: EditOAuthConnectionDialogBodyProps) {

    const refreshCredentials = (
        firstConnectionType: string) => {
        const credentialsQuery: ResourceQuery<IOAuthCredential> =
            OAuthCredentials.all().addFilter(Filter.fieldEq('type', firstConnectionType));

        return SliceableHelper.fetchAll(credentialsQuery)
            .then((credentialsListResult: ListResult<IOAuthCredential>) => {
                props.updateDialogState({ credentials: credentialsListResult.items });
                return credentialsListResult; // For chaining
            });
    };

    const handleToggleChange = (isOAuthCredentialOption: boolean) => {
        if (isOAuthCredentialOption) {
            props.updateDialogState({ credentialOption: 'oauth' });
        } else {
            props.updateDialogState({ credentialOption: 'none' });
        }
    };

    const handleCredentialIdChange = (credentialId: string) => {
        if (credentialId === props.addNewOAuthCredentialOptionValue) {
            props.updateDialogState({
                credentialId: undefined,
            });
            const firstConnection: EditableConnection = props.firstConnection;
            const firstConnectionType = firstConnection.connectionType;
            const firstConnectionDetails = firstConnection.connectionDetails;
            let instanceUrl: string;
            let role: string;
            if (firstConnectionDetails.type === 'database') {
                instanceUrl = firstConnectionDetails.instanceUrl;
                role = firstConnectionDetails.role;
            }

            AddOAuthCredentialAction.attemptAuth(firstConnectionType, instanceUrl, role).then((credentialId: string) => {
                refreshCredentials(firstConnectionType).then((credentialsListResult: ListResult<IOAuthCredential>) => {
                    // Set the credentialId if it exists in the list
                    if (_.find(credentialsListResult.items, (credential: IOAuthCredential) => credential.id === credentialId)) {
                        props.updateDialogState({
                            credentialId: credentialId,
                        });
                    }
                });
            });
        } else {
            props.updateDialogState({ credentialId: credentialId });
        }
    };
    return (
        <>
            <EditOAuthConnectionDialogPrompt prompt={props.prompt} />
            <div style={{ width: '100%' }}>
                <EditOAuthConnectionDialogEmbeddedToggle
                    credentialNoValueOptionText={props.dialogState.credentialNoValueOptionText}
                    currentConnectionTypeDisplayName={props.currentConnectionTypeDisplayName}
                    addNewOAuthCredentialOptionValue={props.addNewOAuthCredentialOptionValue}
                    credentialId={props.dialogState.credentialId}
                    credentials={props.dialogState.credentials}
                    credentialOption={props.dialogState.credentialOption}
                    handleToggleChange={handleToggleChange}
                    handleCredentialIdChange={handleCredentialIdChange}
                />
                <EditOAuthConnectionDialogTestConnection
                    dialogState={props.dialogState}
                    onTestConnection={props.testConnection}
                    isTestConnectionDisabled={props.isTestConnectionDisabled(props.dialogState)}
                />

            </div>
        </>
    );
}
